import NavBar from "../elements/navBar";
import Footer from "../elements/footer";
import VideoHeader from "../newServices/videoHeader";
import NewServices from "../newServices/newServices";
import { Helmet } from "react-helmet";

function Services() {
  return (
    <div style={{overflowX:"hidden"}}>
       <Helmet>
        <title>MakerSpace Machines</title>
       <meta name="description" content="MakerSpace to make your ideas with our equipments and technical support. Come and create your stuff by your own." />
       <meta name="keywords" content="Maker Space, 3D Printing, Wood Cutting, Laser Cutting, CNC Routing, PCB Fabrication, Milling, Equipment and machines" />
         </Helmet>
        <NavBar type="service" />
        <VideoHeader />
     
        <NewServices />
      <Footer />
    </div>
  );
}
export default Services;
